import { CheckSquare } from "lucide-react";

const audiences = [
  {
    id: "builders",
    text: "Builders who want consistent pricing",
  },
  {
    id: "civil-contractors",
    text: "Civil contractors quoting drainage, driveways, retaining, small earthworks",
  },
  {
    id: "busy-teams",
    text: "Teams who are too busy to estimate properly",
  },
  {
    id: "underpricing",
    text: "Anyone sick of winning work by underpricing it",
  },
];

export default function WhoItsFor() {
  return (
    <section
      id="audience"
      className="py-16 md:py-24 border-t-4 border-black bg-white"
      data-testid="audience-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left: Content */}
          <div>
            {/* Section header */}
            <div className="mb-8 md:mb-12">
              <span className="font-mono text-sm uppercase tracking-widest text-zinc-500">
                03 — Who It's For
              </span>
              <h2
                className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase mt-4"
                data-testid="audience-title"
              >
                Built For Builders
              </h2>
            </div>

            {/* Audience list - fixed equal spacing */}
            <ul className="space-y-4">
              {audiences.map((item) => (
                <li
                  key={item.id}
                  className="flex items-center gap-4 py-2"
                  data-testid={`audience-${item.id}`}
                >
                  <div className="w-8 h-8 border-2 border-black flex items-center justify-center flex-shrink-0">
                    <CheckSquare size={18} strokeWidth={1.5} />
                  </div>
                  <p className="font-body text-lg text-zinc-800">
                    {item.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Image */}
          <div className="hidden md:block">
            <div className="border-4 border-black overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_builder-estimates/artifacts/1f491teq_IMG_1076.jpeg"
                alt="Construction site framing"
                className="w-full h-80 object-cover grayscale"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
